
import "./PlayerPanel.css";

const PlayerPanel = ({player, isPlayerSelected, ChangePlayerSelection}) => {

    const getClassNames = () => {
        return isPlayerSelected(player) ? "playerPanel selectedPlayerPanel" :  "playerPanel";
    }

    return (
        <div className={getClassNames()} onClick={() => ChangePlayerSelection(player) }>
            <div className="gap-1 flex">
                <span className="text-glwhite-600">[{player.inGameId}]</span>
                <div>{player.nickname}</div>
            </div>
        </div>
    )
}

export default PlayerPanel;